var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MyUploadPlus',{attrs:{"accept":_vm.accept,"disabled":_vm.disabled},model:{value:(_vm.form.videoUrls),callback:function ($$v) {_vm.$set(_vm.form, "videoUrls", $$v)},expression:"form.videoUrls"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }